import type { ConfigsListRow } from "@/admin/entities/configs";
import type { ConfigsListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: ConfigsListRow[];
  count: number;
} {
  const list = (data as ConfigsListQueryType)?.configs;

  if (!list?.nodes) {
    return { nodes: [], count: 0 };
  }

  return list;
}

export function mapColumns(row: ConfigsListRow) {
  return [row.id, row, row.value, row.createdAt];
}
